import React from 'react';
import { PracticeSession } from '../../utils/activityHelpers';
import { formatDistanceToNow } from '../../utils/formatters';
import { CheckCircle2, XCircle, MinusCircle } from 'lucide-react';
interface ActivityTimelineProps {
  sessions: PracticeSession[];
  emptyMessage?: string;
}
export function ActivityTimeline({
  sessions,
  emptyMessage = 'Geen recente activiteit'
}: ActivityTimelineProps) {
  if (sessions.length === 0) {
    return <div className="text-center py-8 text-slate-500 italic text-sm" data-id="element-2416" data-mp="u36oa157liei">
        {emptyMessage}
      </div>;
  }
  return <div className="space-y-4" data-id="element-2417" data-mp="z3kjujpmizvn">
      {sessions.map((session, i) => {
      let statusIcon = <MinusCircle className="w-5 h-5 text-amber-500" data-id="element-2418" data-mp="kcbqbziloud8" />;
      let statusBg = 'bg-amber-50 border-amber-100';
      if (session.accuracy >= 80) {
        statusIcon = <CheckCircle2 className="w-5 h-5 text-emerald-500" data-id="element-2419" data-mp="1d0zd5zizzrsw" />;
        statusBg = 'bg-emerald-50 border-emerald-100';
      } else if (session.accuracy < 50) {
        statusIcon = <XCircle className="w-5 h-5 text-rose-500" data-id="element-2420" data-mp="bnj3xdnszbyy" />;
        statusBg = 'bg-rose-50 border-rose-100';
      }
      return <div key={i} className="flex gap-4 relative" data-id="element-2421" data-mp="6p7s4xdy6re3" data-mpi={i}>
            {/* Timeline line */}
            {i !== sessions.length - 1 && <div className="absolute left-5 top-10 bottom-[-16px] w-0.5 bg-slate-200" data-id="element-2422" data-mp="kh4f6n0reb3m" />}

            <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 flex-shrink-0 z-10 bg-white ${statusBg.split(' ')[1]}`} data-id="element-2423" data-mp="fobdy94i1kwa">
              
              <span className="text-lg" data-id="element-2424" data-mp="pf5xv6u9w8ek">{session.moduleIcon}</span>
            </div>

            <div className={`flex-1 p-3 rounded-xl border ${statusBg}`} data-id="element-2425" data-mp="phjsjel1jill">
              <div className="flex justify-between items-start mb-1" data-id="element-2426" data-mp="13ef7fnnz449k">
                <h4 className="font-bold text-slate-800" data-id="element-2427" data-mp="zeertzp51n0x">
                  {session.moduleTitle}
                </h4>
                <span className="text-xs font-medium text-slate-500" data-id="element-2428" data-mp="356tvz5l0w6yy">
                  {formatDistanceToNow(session.date)}
                </span>
              </div>
              <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-2429" data-mp="144m2med8c0l6">
                <span data-id="element-2430" data-mp="1936xdy9pps28">{session.questionCount} vragen</span>
                <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-2431" data-mp="193p2lkecrgma" />
                <span className="flex items-center gap-1" data-id="element-2432" data-mp="1e18j6qyiw5he">
                  {statusIcon} {session.accuracy}% goed
                </span>
              </div>
            </div>
          </div>;
    })}
    </div>;
}